import { render, staticRenderFns } from "./test-portal-web.vue?vue&type=template&id=c7862768&"
import script from "./test-portal-web.vue?vue&type=script&lang=js&"
export * from "./test-portal-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-web.vue"
export default component.exports